const BUILDING_IMAGE_KEY_PREFIX = 'buildingImage_';

export const cacheBuildingImage = (buildingId: number, base64Data: string): string => {
  const dataUrl = base64Data.startsWith('data:')
    ? base64Data
    : `data:image/webp;base64,${base64Data}`;
  try {
    localStorage.setItem(`${BUILDING_IMAGE_KEY_PREFIX}${buildingId}`, dataUrl);
  } catch {
    // localStorage quota exceeded
  }
  return dataUrl;
};

export const getCachedBuildingImage = (buildingId: number): string | null => {
  return localStorage.getItem(`${BUILDING_IMAGE_KEY_PREFIX}${buildingId}`);
};

export const getBuildingBackground = (buildingId?: number | null): string => {
  const numericId = Number(buildingId ?? 0);
  if (numericId > 0) {
    return getCachedBuildingImage(numericId) ?? '/buildings/default.webp';
  }
  return '/buildings/default.webp';
};
